import script from "./ModalInvoice.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalInvoice.vue?vue&type=script&setup=true&lang=js"

import "./ModalInvoice.vue?vue&type=style&index=0&id=2451a50c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2451a50c"]])

export default __exports__